__turbopack_context__.v({
  "listingsList": "listings-list-module-scss-module__3Z1MhG__listingsList",
  "listingsList__isMapView": "listings-list-module-scss-module__3Z1MhG__listingsList__isMapView",
  "listingsList__list": "listings-list-module-scss-module__3Z1MhG__listingsList__list",
  "listingsList_listingCard": "listings-list-module-scss-module__3Z1MhG__listingsList_listingCard",
  "listingsList_loadMoreTrigger": "listings-list-module-scss-module__3Z1MhG__listingsList_loadMoreTrigger",
  "listingsList_loadPreviousPage": "listings-list-module-scss-module__3Z1MhG__listingsList_loadPreviousPage",
  "listingsList_loader": "listings-list-module-scss-module__3Z1MhG__listingsList_loader",
  "listingsList_mapViewSwitch": "listings-list-module-scss-module__3Z1MhG__listingsList_mapViewSwitch",
});
